module.exports = __webpack_public_path__ + "img/shop1.a13b21df.png";